export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";